(function () {
  // nav solid on scroll
  var nav = document.getElementById('nav');
  function onScroll() {
    if (!nav) return;
    if (window.scrollY > 60) nav.classList.add('solid'); else nav.classList.remove('solid');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  // slide-out menu
  var burger = document.getElementById('burger');
  var overlay = document.getElementById('menuOverlay');
  var panel = document.getElementById('menuPanel');
  var menuClose = document.getElementById('menuClose');
  function openMenu() {
    overlay.classList.add('open'); panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    overlay.classList.remove('open'); panel.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  if (panel) panel.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
})();
